export const alienNumber = '[0-9]{7}[0-9]{0,2}'
export const phone = '[0-9]{3}-[0-9]{3}-[0-9]{4}'
export const schoolGrade = '[0-9][0-3]?'
export const singleLetter = '^[A-Za-z]'
export const zip = '[0-9]{5}(?:-[0-9]{4})?$'
// Address Line 1 and 2, Mailing Address Line 1 and 2,
// First Name, Last Name, School Name, City, Current Employer Name, Lay Off Employer Name
export const name = '[ \#&\(\),\-\/.0-9A-Za-z]*'